export default __webpack_public_path__ + "static/media/V3.8c8f314a.mp4";